import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PROCESSO_UTILIZACAO.BUSCAR_POR_FILTRO]({ state }) {
		const { filtro, paginacao } = state
		const { data } = await api.processoUtilizacao.buscarPorFiltro(filtro, paginacao)
		return data
	},
	async [actionTypes.PROCESSO_UTILIZACAO.BUSCAR_URL_PROCESSO_UTILIZACAO_LEGADO]({ state }, processoUtilizacao) {
		const { data } = await api.processoUtilizacao.buscarUrlProcessoUtilizacaoLegado(processoUtilizacao)
		return data
	},
	async [actionTypes.PROCESSO_UTILIZACAO.BUSCAR_ORGAOS]() {
		const { data } = await api.processoUtilizacao.buscarOrgaos()
		return data
	},
}
